import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { getLabelFromCode } from '../../core/state_selectors';
import styles from '../car_details_for_rego_motorweb/car_details_for_rego_motorweb.css';
import { DetailsRow } from './details_row';

/**
 * Render the Car Details component
 * @param {Object} props - the incoming set of props
 * @returns {Node} A component
 */

const CarDetailsPlayback = ({ className = '' }) => {
    const make = useSelector((state) => getLabelFromCode(state, 'coverDetail.vehicle.make', 'vertical.quote.apiResponses.makes'));
    const model = useSelector((state) => getLabelFromCode(state, 'coverDetail.vehicle.model', 'vertical.quote.apiResponses.models'));
    const body = useSelector((state) => getLabelFromCode(state, 'coverDetail.vehicle.body', 'vertical.quote.apiResponses.bodies'));
    const fuel = useSelector((state) => getLabelFromCode(state, 'coverDetail.vehicle.fuel', 'vertical.quote.apiResponses.fuel'));
    const year = useSelector((state) => getLabelFromCode(state, 'coverDetail.vehicle.year', 'vertical.quote.apiResponses.years'));

    return (
        <div className={classNames(styles.root, className)}>
            <DetailsRow
                make={make}
                model={model}
                body={body}
                fuel={fuel}
                year={year}
            />
        </div>
    );
};

CarDetailsPlayback.propTypes = {
    className: PropTypes.string.isRequired
};

export { CarDetailsPlayback };
